import styled from 'styled-components';
import { COLORS, breakPoint } from '@ertelecom/ui-react/assets/js/constants';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import CardChannel from '../../../components/Channels/cardChannel';

export const Wrapper = styled(GridContainer)`
    display: block;
    padding-top: 60px;

    @media(${breakPoint(1024)}) {
        padding-top: 50px;
    }

    @media(${breakPoint(768)}) {
        padding-top: 146px;
    }

    @media(${breakPoint(768)}) {
        padding-top: 126px;
    }
`;

export const Title = styled.div`
    font: 300 32px/40px "Roboto", sans-serif;
    color: ${COLORS.black};
    display: block;
    border-bottom: 1px solid ${COLORS.grey};
    padding-bottom: 16px;

    @media(${breakPoint(1024)}) {
        font-size: 24px;
        line-height: 32px;
        padding-bottom: 12px;
    }

    @media(${breakPoint(320)}) {
        font-size: 20px;
        line-height: 28px;
        padding-bottom: 11px;
    }
`;

export const TitleAdditionalChannels = styled(Title)`
    margin-top: 55px;

    @media(${breakPoint(1366)}) {
        margin-top: 48px;
    }

    @media(${breakPoint(1024)}) {
        margin-top: 42px
    }

    @media(${breakPoint(320)}) {
        margin-top: 38px;
    }
`;

export const TitleCanConnect = styled(Title)`
    margin-top: 120px;

    @media(${breakPoint(1366)}) {
        margin-top: 48px;
    }

    @media(${breakPoint(1024)}) {
        margin-top: 42px
    }

    @media(${breakPoint(320)}) {
        margin-top: 38px;
    }
`;

export const WrapperChannel = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding-top: 42px;
    margin: -32px -16px 0;

    @media(${breakPoint(1366)}) {
        padding-top: 30px;
        margin: -24px -12px 0;
    }

    @media(${breakPoint(1024)}) {
        margin: -16px -8px 0;
    }

    @media(${breakPoint(768)}) {
        margin: -20px -10px 0;
    }

    @media(${breakPoint(320)}) {
        margin: 0;
    }
`;

export const CardChannelGrid = styled(CardChannel)`
    margin: 32px 16px 0;
    width: calc(100% / 2 - 32px);

    @media(${breakPoint(1366)}) {
        margin: 24px 12px 0;
        width: calc(100% / 2 - 24px);
    }

    @media(${breakPoint(1024)}) {
        margin: 16px 8px 0;
        width: calc(100% / 2 - 16px);
    }

    @media(${breakPoint(768)}) {
        margin: 20px 10px 0;
        width: calc(100% / 2 - 20px);
    }

    @media(${breakPoint(320)}) {
        margin: 15px 0 0;
        width: 100%;
    }
`;

export const CanConnectGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -16px;
    margin-right: -16px;
    margin-top: 42px;
    margin-bottom: -56px;

    @media(${breakPoint(1366)}) {
        margin-left: -12px;
        margin-right: -12px;
        margin-bottom: -40px;
        margin-top: 30px;
    }

    @media(${breakPoint(1024)}) {
        margin-left: -8px;
        margin-right: -8px;
    }

    @media(${breakPoint(768)}) {
        margin-left: -10px;
        margin-right: -10px;
        margin-bottom: -30px;
    }

    @media(${breakPoint(320)}) {
        margin-left: 0;
        margin-right: 0;
        margin-top: 35px;
    }
`;

export const CanConnectItem = styled.div`
    display: block;
    flex-shrink: 0;
    padding-left: 16px;
    padding-right: 16px;
    width: 25%;
    margin-bottom: 56px;

    @media(${breakPoint(1366)}) {
        width: 33.333333%;
        padding-left: 12px;
        padding-right: 12px;
        margin-bottom: 40px;
    }

    @media(${breakPoint(1024)}) {
        width: 50%;
        padding-left: 8px;
        padding-right: 8px;
    }

    @media(${breakPoint(768)}) {
        width: 50%;
        padding-left: 10px;
        padding-right: 10px;
        margin-bottom: 30px;
    }

    @media(${breakPoint(320)}) {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
`;
